import   axios                from 'axios';

import { API_URLS           } from '../urls';
import { BackendResponse    ,
         handleError        } from '../../dataTypes/backendServicesManagment/types';

import { AdminActionLogEntry } from '../../dataTypes/adminActionLogManagment/types';
import { utcTimesToLocalInText } from '../../utils/utils_utcToLocalInText';

const transformAdminActionLogEntry = (data: any): AdminActionLogEntry => ({
  id          : data.id ,
  adminId     : data.adminId ?? 0 ,
  adminEmail  : data.adminEmail ?? '' ,
  module      : data.module ?? '' ,
  action      : data.action ?? '' ,
  result      : data.result ?? '' ,
  comment     : utcTimesToLocalInText ( data.comment ?? '' ) ,
  elementType : data.elementType ?? null ,
  elementId   : data.elementId ?? null ,
  elementLabel: data.elementType ? `${data.elementType}${data.elementId !== null && data.elementId !== undefined ? ` #${data.elementId}` : ''}` : '—' ,
  actionDate  : data.actionDate ? new Date(data.actionDate) : new Date() ,
  ipAddress   : data.ipAddress ?? '' ,
});

export interface BackendResponse_AdminActionLogList extends BackendResponse<AdminActionLogEntry[]> {}

export const getAdminActionLogs = async (adminId: number): Promise<BackendResponse_AdminActionLogList> => {

  const url = `${API_URLS.getAdminActionLogList}?adminId=${adminId}`;

  try {
    const response = await axios.get(url);

    if (response.status === 200 && Array.isArray(response.data)) {
      return {
        code: 1,
        comment: 'Les logs ont été récupérés avec succès.',
        payload: response.data.map(transformAdminActionLogEntry),
      };
    }
    return handleError<AdminActionLogEntry[]>(response.status, 'Réponse non-200.', []);
  } catch (error) {
    if (axios.isAxiosError(error)) {
      return handleError<AdminActionLogEntry[]>(-101, error.response?.data?.error ?? error.message, []);
    }
    return handleError<AdminActionLogEntry[]>(-102, 'Erreur inconnue.', []);
  }
};
